<template>
  <div class="wrapper-total">
    <div class="profile-wrapper">
      <div class="profile-top-bar">
        <div class="profile-panel-group">
          <div
            class="profile-panel"
            :class="{ active: showing === 'nfts' }"
            @click="show('nfts')"
          >
            <p>
              NFTs
              <!--              <span class="profile-panel-total-items">{{-->
              <!--                nftsList.total-->
              <!--              }}</span>-->
            </p>
          </div>
          <!-- <div
            class="profile-panel"
            :class="{ active: showing === 'pools' }"
            @click="show('pools')"
          >
            <p>
              Pools
              <span class="profile-panel-total-items">{{
                poolsList.total
              }}</span>
            </p>
          </div> -->
        </div>
      </div>
      <div class="profile-panel-body">
        <component :is="currentShowingPanel(showing)" />
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import NftPanel from "@/components/Profile/NftPanel";
import PoolsPanel from "@/components/Profile/PoolsPanel";
import useProfilePanels from "@/composables/useProfilePanels";

export default {
  components: {
    NftPanel,
    PoolsPanel,
  },
  setup() {
    const { nftsList, poolsList, showing, show } = useProfilePanels(useStore());
    const currentShowingPanel = (showing) =>
      showing === "nfts" ? "NftPanel" : "PoolsPanel";
    return {
      show,
      showing,
      nftsList,
      poolsList,
      currentShowingPanel,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/profilePanels.scss"></style>
